import {
  WORKFLOW_STANDARD_ACTION_KEYS,
  WorkflowStandardActionKey
} from '../workflow-actions/workflow-action-catalog.types';
import { WorkflowTaskDecision, WorkflowTaskSurfaceOutcome } from './workflow-task-context';

const decisionToActionKey: Record<WorkflowTaskDecision, WorkflowStandardActionKey> = {
  approved: WORKFLOW_STANDARD_ACTION_KEYS.approve,
  rejected: WORKFLOW_STANDARD_ACTION_KEYS.reject,
  changesRequested: WORKFLOW_STANDARD_ACTION_KEYS.requestChanges
};

export function buildTaskCompletionOutput(
  decision: WorkflowTaskDecision,
  reason: string,
  payload: Record<string, unknown> = {},
  actionKey?: string
): string {
  const output: Record<string, unknown> = {
    decision,
    actionKey: actionKey ?? decisionToActionKey[decision]
  };

  if (reason.trim()) {
    output['reason'] = reason.trim();
  }

  if (Object.keys(payload).length > 0) {
    output['payload'] = payload;
  }

  return JSON.stringify(output);
}

export function mergeSurfaceOutcome(
  outcome: WorkflowTaskSurfaceOutcome | null,
  reason: string,
  payload: Record<string, unknown> = {}
): string {
  if (!outcome) {
    return buildTaskCompletionOutput('approved', reason, payload);
  }

  return buildTaskCompletionOutput(
    outcome.decision,
    outcome.reason ?? reason,
    { ...payload, ...(outcome.payload ?? {}) }
  );
}

/** Builds a standard entity id payload nested under `payload` for outputMapping extraction. */
export function buildSurfaceEntityPayload(
  entityKey: string,
  entityId: string | null | undefined
): Record<string, unknown> {
  if (!entityId) {
    return {};
  }

  return { [entityKey]: entityId };
}
